// OrganizationContext.js — thin re-export from AppDataContext
import React from 'react';
import { useAppData } from './AppDataContext';

export const useOrganization = () => {
  const appData = useAppData();
  return {
    organizations: appData.organizations,
    currentOrganization: appData.currentOrganization,
    loading: appData.loading,
    error: appData.error,
    loadUserOrganizations: appData.refreshOrganizations,
    refreshOrganizations: appData.refreshOrganizations,
    loadFeatures: () => {},
    switchOrganization: appData.switchOrganization,
    createOrganization: appData.createOrganization,
    updateOrganization: appData.updateOrganization,
    deleteOrganization: appData.deleteOrganization,
    getCurrentUserRole: appData.getCurrentUserRole,
    hasRole: appData.hasRole,
    canManageOrganization: appData.canManageOrganization,
    isOrganizationOwner: appData.isOrganizationOwner,
    hasPermission: appData.hasRole,
    userWithOrgs: null,
    features: [],
  };
};

export const OrganizationProvider = ({ children }) => <>{children}</>;
